export const languageOptions = [
    { value: "en", label: "English" },
    { value: "de", label: "Deutsch" },
    { value: "es", label: "español" },
    { value: "fr", label: "français" },
]

export default languageOptions